
import { getProductCategories } from "@dillon/Services/CommonServices";
import { setGA4Event } from "@dillon/Store/Handlers/Utilities/CustomTracking";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { markSkipOnCompleteIfOnSuccessIsSet, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import { CartLineModel, OrderLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

replaceInChain(chain, ExecuteOnSuccessCallback, async props => {
    const state = props.getState();
    const {
        pages: {
            productList: {
                productFilters: { pageCategoryId },
            },
        },
    } = state;

    if (!props.result?.errorMessage && props.parameter.onSuccess) {       
        const currentPath = window.location.pathname;
        if (currentPath === "/Cart") {
            isCartPage(state,props.parameter.productInfos);
        } else if(currentPath === "/MyAccount/Orders/Details") {
            isOrderPage(state,props.parameter.productInfos);
        }else{
            let products: Array<{ product: ProductModel; productInfo: Omit<ProductInfo, "productDetailPath"> }> = [];
            if (props.parameter.productInfos) {
                products = props.parameter.productInfos
                    .map(productInfo => {                    
                            const productState = getProductState(state, productInfo.productId);
                            if (productState?.value) {
                                return {
                                    product: productState.value,
                                    productInfo,
                                };
                            }                    
                        return null;
                    })
                    .filter(
                        (
                            product,
                        ): product is { product: ProductModel; productInfo: Omit<ProductInfo, "productDetailPath"> } =>
                            product !== null,
                    );
            }
    
            if (products.length > 0) {            
                const productIds = products
                    .map(p => p.product.id)
                    .filter(id => id !== null && id !== undefined) as string[];
    
                const result = await getProductCategories({
                    productIds: productIds || [], // Ensure productIds is always an array
                    type: "product",
                });
    
                if (result.successful) {
                    const productCategories = result.result;
    
                    setGA4Event(products,"add_to_wishlist", {
                        productCategories,
                    });
                }
            }
        }       

        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess(props.result.wishList!);
    }
});

async function isCartPage(state: any, productInfos: Omit<ProductInfo, "productDetailPath">[]){
    const cartState = getCurrentCartState(state).value;
    let products: CartLineModel[] | null | undefined;
    
    if (cartState) {
        products = cartState.cartLines;
        if(products){     
            products = products.filter(p => productInfos.some(pi => pi.productId === p.productId));  
        }
     }

    if (products!= null && products.length > 0) {            
        const productIds = products
            .map(p => p.productId)
            .filter(id => id !== null && id !== undefined) as string[];

        const result = await getProductCategories({
            productIds: productIds || [], // Ensure productIds is always an array
            type: "product",
        });

        if (result.successful) {
            const productCategories = result.result;

            setGA4Event(products,"add_to_wishlist", {
                productCategories,
            });
        }
    }
}

async function isOrderPage(state: any, productInfos: Omit<ProductInfo, "productDetailPath">[]){
    const orderNumber = window.location.search.split("=")[1];
    const orderState = getOrderState(state, orderNumber);
    let products: OrderLineModel[] | null | undefined;
    
    if (orderState) {
        products = orderState.value?.orderLines;
        if(products){     
            products = products.filter(p => productInfos.some(pi => pi.productId === p.productId));  
        }
     }

    if (products!= null && products.length > 0) {            
        const productIds = products
            .map(p => p.productId)
            .filter(id => id !== null && id !== undefined) as string[];

        const result = await getProductCategories({
            productIds: productIds || [], // Ensure productIds is always an array
            type: "product",
        });

        if (result.successful) {
            const productCategories = result.result;

            setGA4Event(products,"add_to_wishlist", {
                productCategories,
            });
        }
    }
}